// @ts-nocheck
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  forwardRef,
  inject,
} from '@angular/core';
import moment from 'moment';
import { GLOBAL_CONSTANT } from '../../../../contants/global.const';
import { SEND_SERVICE } from '../../../../services/send.service';
import { EntityFieldsComponent } from '../../dynamic-form/sub-modules/sub-form/entity-fields/entity-fields.component';
import { DatePickerComponent } from '../date-picker/date-picker.component';
import { InputTextComponent } from '../input-text/input-text.component';

interface IValues {
  reference_date: number;
  update_index: string;
  type_exchange_rate: string;
  dolar_quotation: number;
  payValue: number;
  payValueUS: number;
  updated_value: string;
  updated_value_us: string;
}

@Component({
  selector: 'legalboxplus-monetary-semi-form',
  templateUrl: './monetary-semi-form.component.html',
  styleUrl: './monetary-semi-form.component.scss',
  imports: [forwardRef(() => EntityFieldsComponent), DatePickerComponent, InputTextComponent],
})
export class MonetarySemiFormComponent implements OnInit, AfterViewInit {
  readonly sendService = inject(SEND_SERVICE);
  readonly Global = inject(GLOBAL_CONSTANT);

  @Output('changeValue') changeValueEmmiter = new EventEmitter();
  @Output('focusState') focusStateEmmiter = new EventEmitter();

  @Input('value') set setValues(value) {
    this.values = {
      reference_date: value?.reference_date ?? this.values.reference_date,
      update_index: value?.update_index ?? this.values.update_index,
      type_exchange_rate: value?.type_exchange_rate ?? this.values.type_exchange_rate,
      dolar_quotation: value?.dolar_quotation ?? this.values.dolar_quotation,
      updated_value: value?.updated_value ?? this.values.updated_value,
      updated_value_us: value?.updated_value_us ?? this.values.updated_value_us,
      payValue: Math.round((value?.payValue ?? this.values.payValue) * 100) / 100,
      payValueUS: Math.round((value?.payValueUS ?? this.values.payValueUS) * 100) / 100,
    };
  }

  loading_updated_value = false;
  loading_updated_value_us = false;
  loading_dolar_quotation = false;

  private calcalculationUpdateValuesTimeout: any = null;

  private _currentExchangeRate!: number;
  public get currentExchangeRate(): number {
    return this._currentExchangeRate;
  }
  public set currentExchangeRate(value: number) {
    this.values.dolar_quotation = value;
    this._currentExchangeRate = value;
  }

  ngAfterViewInit(): void {
    for (const entityKey in this.values) {
      this.changeValueEmmiter.emit({ entityKey, value: this.values[entityKey] });
    }
  }

  ngOnInit(): void {
    this.getExchangeRate();
  }

  public values: IValues = {
    reference_date: undefined as any,
    update_index: '/monetary-rate/no-apply',
    type_exchange_rate: '1',
    dolar_quotation: 0,
    payValue: 0,
    payValueUS: 0,
    updated_value: undefined as any,
    updated_value_us: undefined as any,
  };

  public fields = {
    update_index: {
      auxEntity: {
        listOptions: [
          {
            value: '/monetary-rate/igpm-legacy',
            label: 'IGP-M - Legal Box',
          },
          {
            value: '/monetary-rate/no-apply',
            label: 'Não se aplica',
          },
        ],
      },
      label: 'Índice de Atualização',
    },
    type_exchange_rate: {
      auxEntity: {
        listOptions: [
          {
            value: 'noApply',
            label: 'Não se aplica',
          },
          {
            value: '1',
            label: 'Dólar comercial',
          },
          {
            value: '2',
            label: 'Cotação Manual ',
          },
        ],
      },
      label: 'Tipo de Cambio',
    },
  };

  public getExchangeRate() {
    const url = this.Global.services.monetaryRate.exchangeRate();
    const params = {
      code: 'BRL',
      codein: 'USD',
      startDate: String(moment().unix()),
      value: '1',
    };
    this.loading_dolar_quotation = true;
    this.sendService.get(url, { params }).subscribe(
      (resp) => {
        this.currentExchangeRate = resp;
        this.loading_dolar_quotation = false;
      },
      () => {
        this.loading_dolar_quotation = false;
      }
    );
  }

  public setErrorState($event, entityKey) {}

  public setValidState($event, entityKey) {}

  public changeField($event, entityKey) {
    if (entityKey !== 'payValueUS' && entityKey !== 'payValue' && entityKey !== 'dolar_quotation')
      this.values[entityKey] = $event;

    const { dolar_quotation, payValue, payValueUS } = this.values;

    if (entityKey === 'type_exchange_rate') {
      if ($event === '1') this.values.dolar_quotation = this.currentExchangeRate;
      if ($event === 'noApply') {
        this.values.payValueUS = 0;
        this.values.payValue = 0;
        this.values.dolar_quotation = 0;
      }

      this.changeValueEmmiter.emit({
        entityKey: 'payValueUS',
        value: this.values.payValueUS?.toFixed(2),
      });
      this.changeValueEmmiter.emit({
        entityKey: 'dolar_quotation',
        value: this.values.dolar_quotation?.toFixed(2),
      });
    }

    if (entityKey === 'dolar_quotation') {
      this.values.payValue = payValueUS * (Number($event) || 0);
    }

    if (entityKey === 'payValueUS') {
      this.values.payValueUS = Number($event);
      this.values.payValue = Number($event) * (Number(dolar_quotation) || 1);
    }

    this.calcalculationUpdateValues();

    if (entityKey === 'dolar_quotation' || entityKey === 'payValue' || entityKey === 'payValueUS')
      this.changeValueEmmiter.emit({ entityKey, value: this.values[entityKey]?.toFixed(2) });
    else this.changeValueEmmiter.emit({ entityKey, value: this.values[entityKey] });
  }

  public focusState($event, entityKey) {
    this.focusStateEmmiter.emit($event);
  }

  public toNumber($event) {
    return Number($event);
  }

  private calcalculationUpdateValues() {
    clearTimeout(this.calcalculationUpdateValuesTimeout);

    this.calcalculationUpdateValuesTimeout = setTimeout(() => {
      const url = this.Global.services.monetaryRate.correctionCalculation();
      const params = {
        indexRateName: this.values.update_index,
        value: this.values.payValue?.toFixed(2),
        startDate: String(this.values.reference_date),
        endDate: String(moment().unix()),
        hasInterest: 'false',
        hasPenalty: 'false',
      };
      this.loading_updated_value = true;
      this.loading_updated_value_us = true;
      this.sendService.get(url, { params }).subscribe(
        (data) => {
          this.values.updated_value = data.correctedBalance;
          this.values.updated_value_us = (
            data.correctedBalance /
            (Number(this.values.dolar_quotation) || Number.POSITIVE_INFINITY)
          )?.toFixed(2);
          this.changeValueEmmiter.emit({
            entityKey: 'updated_value',
            value: this.values.updated_value,
          });
          this.changeValueEmmiter.emit({
            entityKey: 'updated_value_us',
            value: this.values.updated_value_us,
          });
          this.loading_updated_value = false;
          this.loading_updated_value_us = false;
        },
        (err) => {
          console.error(err);
          this.loading_updated_value = false;
          this.loading_updated_value_us = false;
        }
      );
    }, 500);
  }
}
